export const CLEAR_STATUS = 'ui/CLEAR_STATUS'

export const SHOW_INFO_MESSAGE = 'ui/SHOW_INFO_MESSAGE'

export const SHOW_UPDATE_MESSAGE = 'ui/SHOW_UPDATE_MESSAGE'

export const SHOW_ERROR_MESSAGE = 'ui/SHOW_ERROR_MESSAGE'
